"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
const PluginRegistry_1 = require("../PluginRegistry/PluginRegistry");
const Filter_1 = require("../Filter");
class Platform {
    constructor(config) {
        this.config = {
            development: false,
            locale: "en",
            ...config
        };
        this.pluginRegistry = new PluginRegistry_1.PluginRegistry({
            development: this.config.development,
            locale: this.config.locale,
            pluginConfigs: this.config.pluginConfigs,
            pluginPaths: this.config.pluginPaths,
        });
        this.filter = new Filter_1.PlatformFilter(this);
    }
    init() {
        return this.pluginRegistry.init();
    }
}
exports.Platform = Platform;
